/**
 * @desc tick utils
 */
import { log } from '../utils/math';
import * as lodash from '../utils/lodash';
export function niceTicks(min, max, tickCount, conf) {
    var forceMinInterval = conf.minInterval, forceMaxInterval = conf.maxInterval, forceInterval = conf.interval, forceTicks = conf.ticks, exactTickCount = conf.exactTickCount, _a = conf.allowDecimals, allowDecimals = _a === void 0 ? true : _a;
    if (lodash.isArray(forceTicks)) {
        return forceTicks.slice().sort(function (a, b) { return a - b; });
    }
    var range = max - min;
    var avgInterval = range / (tickCount - 1);
    var k = Math.floor(log(avgInterval, 10));
    var minInterval = Math.pow(10, k);
    if (!allowDecimals && minInterval < 1) {
        minInterval = 1;
    }
    var interval = minInterval;
    var exactTickCountFlag = false;
    if (exactTickCount) {
        var steps = [];
        var current = 1;
        while (current < 10) {
            steps.push(current);
            current += 0.5;
        }
        steps.push(1.25); // 1.25 * 4 = 5
        steps.push(3.75); // 3.75 * 4 = 15
        steps.push(6.25); // 6.25 * 4 = 25
        steps.push(8.75); // 8.75 * 4 = 35
        // steps.sort((a, b) => a - b)
        var testIntervalList = steps.map(function (step) { return step * minInterval; });
        if (!allowDecimals) {
            testIntervalList = testIntervalList.filter(function (item) { return Math.floor(item) === item; });
        }
        for (var _i = 0, testIntervalList_1 = testIntervalList; _i < testIntervalList_1.length; _i++) {
            var testInterval = testIntervalList_1[_i];
            var tempMin = Math.floor(min / testInterval) * testInterval;
            var tempMax = Math.ceil(max / testInterval) * testInterval;
            var tempCount = Math.round((tempMax - tempMin) / testInterval) + 1;
            if (tempCount === tickCount) {
                interval = testInterval;
                exactTickCountFlag = true;
                break;
            }
        }
    }
    if (!exactTickCount || !exactTickCountFlag) {
        var testIntervalList = [minInterval, minInterval * 2, minInterval * 5, minInterval * 10];
        for (var _b = 0, testIntervalList_2 = testIntervalList; _b < testIntervalList_2.length; _b++) {
            var testInterval = testIntervalList_2[_b];
            if (Math.abs(testInterval - avgInterval) < Math.abs(interval - avgInterval)) {
                interval = testInterval;
            }
        }
    }
    if (lodash.isNumber(forceMinInterval) && Math.abs(interval) < Math.abs(forceMinInterval)) {
        interval = forceMinInterval;
    }
    if (lodash.isNumber(forceMaxInterval) && Math.abs(interval) > Math.abs(forceMaxInterval)) {
        interval = forceMaxInterval;
    }
    if (typeof forceInterval === 'number') {
        interval = forceInterval;
    }
    var realMin = Math.floor(min / interval) * interval;
    var realMax = Math.ceil(max / interval) * interval;
    var realTickCount = Math.round((realMax - realMin) / interval + 1);
    var ticks = [];
    for (var i = 0; i < realTickCount; i += 1) {
        if (typeof forceInterval === 'number') {
            ticks.push(realMin + interval * i);
        }
        else {
            ticks.push(parseFloat((realMin + interval * i).toFixed(k < 0 ? -k + 2 : k + 2)));
        }
    }
    return ticks;
}
